module.exports = __webpack_public_path__ + "img/transport.f0aa2a19.svg";